<script>
	import Globe from './Globe.svelte';
	import Logo from './Logo.svelte';
	import Card from './Card.svelte';
	import { onMount } from 'svelte';

	let heroText, can;
	let state = "FIXED";
	let email1 = "QuadWx";
	let email2 = "gmail.com"
	let sc;

	onMount(() => {
		let globeDim = 0.66*window.innerWidth;
		globeDim = Math.min(750, globeDim);

		if (window.innerWidth < 640) {
			globeDim = window.innerWidth;
		}
		const element = document.getElementById("hero-container");
		const logo = document.getElementById("logo");
		let logoHeight = logo.clientHeight;

		

		heroText = document.getElementById('hero-text');

		//sc = document.getElementById("sc");
		
		heroText.style.height = (window.innerHeight - logoHeight) + "px";

		element.style.height = (globeDim+heroText.clientHeight)+"px";

		can = document.getElementById("can");
		//let top = can.getBoundingClientRect().top - 24;
		let top = can.getBoundingClientRect().top - 24;
		document.addEventListener('scroll', (e) => {
			//console.log(document.documentElement.scrollTop);
			sc = document.getElementById("sc")
			if (sc && document.documentElement.scrollTop > 24) sc.outerHTML = "";

			let bottom = heroText.getBoundingClientRect().bottom;
			
			if (bottom <= top) {
				can.classList.add("rel-globe");
				state = "RELATIVE";
			} else {
				can.classList.remove("rel-globe");
				state = "FIXED"
			}
		})

	});

	let radarOb = {
		text: "View NEXRAD Level II files on the web using an application that brings traditional desktop software to the browser.",
		title: "Radar viewer",
		url:"Katrina.png",
		width:600,
		height:408,
		software:"desktop-only",
		link:"https://radar.quadweather.com/",
	}

	let modelOb = {
		text: "View a selection of numerical weather prediction models including the GFS and HRRR on an interactive map.",
		title: "Model viewer",
		url:"mapbox-logo.png",
		width:600,
		height:408,
		software:"mobile-friendly",
		link:"https://quadweather.com/models"
	}
	

</script>
<main>
	<div id="top" class="top">
		<Logo/>
		<div id="hero-container" class="hero-container">
			<div id="hero-text" class="herotext">
				<p class="ptext">Pushing the boundaries of weather visualization on the web</p>
			</div>
			<Globe state={state}/>
		</div>
		
	</div>
	<div id="apps" class="app-container">
		<h2>Web<br>Applications</h2>
		<Card  {...radarOb}/>
		<Card  {...modelOb}/>
	</div>

	<div class="footer">
        <span class="email">{email1}@{email2}</span>
        <a class="twitter" href="https://twitter.com/QuadWeather">
            <img class="twitter" src="logotwitter.png" alt="twitter">
        </a>
        <a class="email" href="https://twitter.com/QuadWeather">@QuadWeather</a>
		<a class="pp" href="https://quadweather.com/privacy" target="_blank">Privacy Policy</a>
	</div>
	<div id="sc" class="screen-cover">
		<span id="arrow"></span>
	</div>
</main>

<style>
	.pp {
		height: 30px;
		display: block;
		margin: auto;
		margin-left: 48px;
		margin-right: 0;
		line-height: 30px;
		color: inherit;
	}
	main {
		text-align: center;
		padding: 0;
		width:100%;
		margin: 0;
		background-color:white;
	}

	.screen-cover {
		position:absolute;
		width:90%;
		max-width:900px;
		top:0;
		height:100vh;
		height: -webkit-fill-available;
		left:50%;
		transform:translate(-50%,0);
		pointer-events: none;
		z-index: 5;
	}

	#arrow {
		position:absolute;
		right:0px;
		bottom:40px;
		color:white;
		width:40px;
		height:40px;
		font-size: 24px;
		animation: move-arrow 1.5s infinite forwards;
		animation-timing-function: ease-out;
	}

	#arrow::after {
		content: "\2193";
	}

	@keyframes move-arrow {
		0% {
			bottom:35px;
		}

		100% {
			bottom:5px;
		}
	}

	.twitter {
        height: 30px;
        display: block;
        margin: auto;
        margin-left: 24px;
        margin-right: 0;
        
    }
    .email {
        display: block;
        height: 100%;
        line-height: 100px;
        color:inherit;
    }
    .footer {
        
        width: 100%;
        height: 100px;
        background-color: #111;
        color: white;
        display: flex;
        justify-content: center;
    }

	.herotext {
		backdrop-filter: blur(6px);
		-webkit-backdrop-filter: blur(6px);
		width:100%;
		border-radius: 10px;
		height:300px;
		margin:auto;
		position:relative;
		z-index: 2;
	}

	

	.top {
		position: relative;
		z-index: 2;
		background-color: #111;
	}

	.ptext {
		margin: 0;
		color: white;
		font-size: 36px;
		font-weight: bolder;
		position: absolute;
		width: 90%;
		left: 50%;
		top: 30%;
		transform: translate(-50%,0);
		top:0px;

	}

	.hero-container {
		position:relative;
		z-index: 3;
	}

	.app-container {
		background-color: #000;
		overflow:auto;
	}

	h2 {
		font-size: 48px;
		background: -webkit-linear-gradient(#eee, #333);
		background-image: linear-gradient(
		305deg,
		hsl(4deg 93% 47%) 0%,
		hsl(351deg 100% 48%) 0%,
		hsl(345deg 100% 49%) 1%,
		hsl(340deg 100% 50%) 2%,
		hsl(334deg 100% 50%) 5%,
		hsl(327deg 100% 50%) 9%,
		hsl(319deg 100% 48%) 15%,
		hsl(308deg 100% 44%) 24%,
		hsl(293deg 100% 44%) 39%,
		hsl(278deg 100% 50%) 97%
		);
		background-image: linear-gradient( 55deg, hsl(278deg 99% 50%) 0%, hsl(293deg 100% 45%) 27%, hsl(307deg 100% 45%) 44%, hsl(317deg 100% 48%) 55%, hsl(325deg 100% 50%) 64%, hsl(331deg 100% 50%) 71%, hsl(337deg 100% 50%) 78%, hsl(342deg 100% 50%) 84%, hsl(347deg 100% 50%) 91%, hsl(0deg 96% 56%) 100% );
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		text-align: left;
		width: 85%;
		margin: auto;
		max-width: 800px;
		margin-top:2em;
	}

	@media (min-width: 640px) {
		main {
			/* width:100%; */
			/* max-width: 900px; */
			margin:auto;
			max-width: none;
			
		}
		.ptext {
			font-size: 72px;
			max-width: 800px;
			top:50px;
		}

		.herotext {
			width:90%;
		}

		h2 {
			font-size: 72px;
			margin-top: 2em;
		}

		#arrow {
			font-size: 36px;
		}
	}
</style>